<template>
  <VDialog
    :model-value="isDialogVisible"
    max-width="500"
    @update:model-value="updateModelValue"
  >
    <VCard>
      <VCardTitle>
        {{ restaurant.name }}
      </VCardTitle>
      <VCardText class="">
        <span class="text-decoration-underline text-primary">{{ restaurant.name }}</span> is currently marked as <span class="text-decoration-underline font-weight-bold">unlisted</span> in our system. This may be because the restaurant is temporarily closed or they have incomplete Google Place listing information.
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          color="primary"
          @click="confirm"
        >
          I Understand
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script setup>
const props = defineProps({
  isDialogVisible: {
    type: Boolean,
    required: true
  },
  restaurant: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['update:isDialogVisible', 'onNotificationSent'])

const updateModelValue = val => {
  emit('update:isDialogVisible', val)
}

const confirm = () => {
  emit('onNotificationSent')
  emit('update:isDialogVisible', false)
}
</script>
